import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4514d4b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "StepClient" }
const _hoisted_2 = { class: "StepClient__title" }
const _hoisted_3 = { class: "flex items-center justify-end mt-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))
const _hoisted_5 = { class: "flex items-center justify-between" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "StepClient__title" }, "Клиент", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_8 = { class: "mt-2" }
const _hoisted_9 = { class: "font-semibold text-blue-600" }
const _hoisted_10 = { class: "mt-2 text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.state.is_client_selected)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.stepNumber) + ". Выберите клиента", 1),
          _createVNode(_component_the_select, {
            class: "mt-3",
            placeholder: "Клиент",
            disabled: _ctx.disabled,
            loading: _ctx.data_state.clients.is_loading,
            failed: _ctx.data_state.clients.is_failed,
            "error-text": "При получении списка клиентов произошла ошибка",
            options: _ctx.data_state.clients.list,
            value: _ctx.state.client_id,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.client_id) = $event)),
            "infinite-scroll": "",
            label: "fullName",
            onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadClients(_ctx.data_state.clients.pagination.current_page))),
            onLoadmore: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadMoreClients(_ctx.data_state.clients.pagination.current_page + 1))),
            onSearch: _ctx.searchClients,
            onOptionBySearch: _ctx.unshiftFindedClient,
            onChange: _ctx.onClientSelected
          }, null, 8, ["disabled", "loading", "failed", "options", "value", "onSearch", "onOptionBySearch", "onChange"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_the_button, {
              class: "primary text small",
              disabled: !Boolean(_ctx.state.client) || _ctx.disabled,
              onClick: _ctx.selectClient
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createTextVNode(" Подтвердить ")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ])
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_the_button, {
              class: "second text small",
              disabled: _ctx.disabled,
              onClick: _ctx.resetSelectedClient
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _createTextVNode(" Сбросить ")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.state.client.fullName), 1),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("p", null, "Телефон: " + _toDisplayString(_ctx.state.client.phoneNumber), 1)
            ])
          ])
        ], 64))
  ]))
}